// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarToggleButton_toggleButton__GAkwf {
    position: absolute;
    top: 12px;
    left: 8px;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 2px solid #1976d2;
    background: #fff;
    cursor: pointer;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    transition: background 0.2s, border 0.2s;
    font-size: 2rem;
    font-weight: bold;
    color: #1976d2;
}
.SidebarToggleButton_toggleButton__GAkwf:hover {
    background: #e3f0fc;
    border-color: #1565c0;
    color: #1565c0;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SidebarToggleButton/SidebarToggleButton.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;IACtC,wCAAwC;IACxC,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB","sourcesContent":[".toggleButton {\r\n    position: absolute;\r\n    top: 12px;\r\n    left: 8px;\r\n    width: 44px;\r\n    height: 44px;\r\n    border-radius: 50%;\r\n    border: 2px solid #1976d2;\r\n    background: #fff;\r\n    cursor: pointer;\r\n    z-index: 10;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    box-shadow: 0 2px 8px rgba(0,0,0,0.08);\r\n    transition: background 0.2s, border 0.2s;\r\n    font-size: 2rem;\r\n    font-weight: bold;\r\n    color: #1976d2;\r\n}\r\n.toggleButton:hover {\r\n    background: #e3f0fc;\r\n    border-color: #1565c0;\r\n    color: #1565c0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggleButton": `SidebarToggleButton_toggleButton__GAkwf`
};
export default ___CSS_LOADER_EXPORT___;
